export enum OrganizationLevel {
    SYSTEM = "SYSTEM",
    INSTANCE = "INSTANCE",
    CUSTOMER = "CUSTOMER"
}